export var dictionaries = {
  methods: {
    findDictionaryEx(screen, dictionaryName) {
      let result = null;
      const dictionariesEx = screen.dictionariesEx;
      dictionariesEx && dictionariesEx.forEach(dictionaryEx => {
        if (dictionaryEx.dictionary.name == dictionaryName) {
          result = dictionaryEx;
        }
      });
      return result;
    },

    findDictionary(screen, dictionaryName) {
      const dictionaryEx = this.findDictionaryEx(screen, dictionaryName);
      return dictionaryEx ? dictionaryEx.dictionary : {};
    },
  }
}